/**
 * Mobile navigation toggle for the sticky header.
 * Opens/closes the `.nav-panel` (which holds the nav links + CTAs) via the
 * custom `.nav-toggle` hamburger. No-op if the header markup isn't present.
 */
export function initMenu() {
	const nav = document.querySelector('.site-nav');
	const toggle = nav && nav.querySelector('.nav-toggle');
	if (!nav || !toggle) return;

	const close = () => {
		nav.classList.remove('open');
		toggle.setAttribute('aria-expanded', 'false');
	};

	toggle.addEventListener('click', () => {
		const open = nav.classList.toggle('open');
		toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
	});

	// Close after following a link or CTA inside the panel.
	nav.querySelectorAll('.nav-panel a').forEach((a) =>
		a.addEventListener('click', close)
	);

	// Close on Escape.
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') close();
	});
}
